import Vue from 'vue'
import {
    Step,
    Steps,
    Icon,
    Lazyload,
    Swipe,
    SwipeItem,
    Search,
    Card,
    Cell,
    CellGroup,
    Tab,
    Tabs,
    PullRefresh,
    ActionSheet,
    Form,
    Field,
    Toast,
    Calendar,
    Loading,
    Notify,
    DatetimePicker,
    Uploader,
    Dialog,
    Image as VanImage,
    Overlay,
    NavBar,
    CouponCell,
    CouponList,
    List,
    Switch,
    Popup,
} from 'vant'
Vue.use(Search)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Icon)
Vue.use(Card)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(PullRefresh)
Vue.use(ActionSheet)
Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Calendar)
Vue.use(Notify)
Vue.use(DatetimePicker)
Vue.use(Uploader)
Vue.use(Dialog)
Vue.use(VanImage)
Vue.use(Overlay)
Vue.use(NavBar)
Vue.use(CouponCell)
Vue.use(CouponList)
Vue.use(List)
Vue.use(Switch)
Vue.use(Popup)